import { Amplify } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';
import { CONFIGURATION } from '../constants';
import { MemoryStorage } from './memory-storage';

let transicsTokenHeader = null;
let initialized = false;

export const setToken = token => (transicsTokenHeader = token);
export const getToken = () => transicsTokenHeader;
export const initializeConfigs = () => {
  if (initialized) {
    return;
  }

  const getCustomHeader = async () => {
    const token = getToken();
    return token && { 'X-transics-token': token };
  };

  Amplify.configure({
    Auth: {
      identityPoolId: CONFIGURATION.AWS_IDENTITY_POOL,
      region: CONFIGURATION.AWS_REGION,
      /**
       * https://github.com/aws-amplify/amplify-js/issues/6868
       *
       * The custom storage interface is required because workers don't support LocalStorage, Amplify's default store   *
       * 	export interface ICognitoStorage {
       *	setItem(key: string, value: string): void;
       *	getItem(key: string): string | null;
       *	removeItem(key: string): void;
       *	clear(): void;
       * }
       */
      storage: MemoryStorage
    },
    API: {
      endpoints: [
        {
          name: CONFIGURATION.AWS_API_NAME_TRAILERFIT,
          endpoint: CONFIGURATION.AWS_API_GATEWAY_TRAILERFIT,
          region: CONFIGURATION.AWS_REGION,
          custom_header: getCustomHeader
        },
        {
          name: CONFIGURATION.AWS_API_NAME_EBPMS,
          endpoint: CONFIGURATION.AWS_API_GATEWAY_EBPMS,
          region: CONFIGURATION.AWS_REGION,
          custom_header: getCustomHeader
        }
      ]
    }
  });

  Amplify.addPluggable(
    new AWSIoTProvider({
      aws_pubsub_region: CONFIGURATION.AWS_PUBSUB_REGION,
      aws_pubsub_endpoint: CONFIGURATION.AWS_PUBSUB_ENDPOINT
    })
  );
  initialized = true;
};
